<script lang="ts">
  import CredentialManagement from "@modern/components/distributor/credential_management/CredentialManagement.svelte";
  import LoadingSpinner from "@shared/svelte/Components/LoadingSpinner.svelte";
  import * as CredentialManagementService from "@retailer/services/credential_management_service";
  import { onMount, onDestroy } from "svelte";
  import {
    resetCredentialManagementStore,
    CredentialManagementStore,
  } from "@retailer/stores/CredentialManagementStore";

  const fetchCredentials = async (pageNumber?: number) => {
    await CredentialManagementService.getCredentials(pageNumber || 1);
  };

  // lifecycle
  onMount(() => {
    (async () => {
      await Promise.all([fetchCredentials(), CredentialManagementService.getDistributors()]);
    })();
  });

  onDestroy(() => {
    resetCredentialManagementStore();
  });

  // reactives
  $: pagination = {
    ...$CredentialManagementStore.pagination,
    goToPage: nextPageNum => fetchCredentials(nextPageNum),
  };
</script>

{#if !$CredentialManagementStore.loaded}
  <LoadingSpinner />
{:else if $CredentialManagementStore.loaded && !$CredentialManagementStore.failed}
  <CredentialManagement {pagination} />
{/if}
